import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import { Controller } from 'react-hook-form';
import TextInput from '../../../../../styledComponents/styles/TextInput.styled';
import _get from 'lodash/get';

import Popover from '@mui/material/Popover';
import ScreenReaderHeadingComponent from '../../../../travelerProfile/components/heading/ScreenReaderHeadingComponent';



const Header = styled.span`
  color: #0B3544;
  font-size: 28px;
  font-weight: 600;
  line-height: 74px;
`;

const Instructions = styled.div`
  color: #373737;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  text-align: center;
  
  span {
    font-weight: 600;
  }
`;
const PasswordInstructions = styled.div`
  
  button {
    background: none;
    border: none;
    color: #4E6B7A;
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    text-align: center;
    span {
      text-decoration: underline;
    }
  }
`;
const InputContainer = styled.div`
  flex: 1;
  margin: 13px 0;
  text-align: left;
`;

// Step 2.
export default function PasswordStep(props) {
  let { control, errors, setValue, getValues, isValid } = props;
  const [showPasswordInstruction, setShowPasswordInstruction] = useState(null);

  const handleClose = () => {
    setShowPasswordInstruction(null);
  };
  const open = Boolean(showPasswordInstruction);
  const id = open ? 'simple-popover' : undefined;
  
  return (
    <>
      <ScreenReaderHeadingComponent text={'Create your account'} />
      <Header>Create your account</Header>
      <Instructions>Enter your information below</Instructions>
      <PasswordInstructions>
        <button type="button" aria-describedby={id} variant="contained" onClick={(e)=>setShowPasswordInstruction(e.currentTarget)}>
          <span>View Password Requirements</span>
        </button>
        <Popover
        id={id}
        open={open}
        anchorEl={showPasswordInstruction}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        
          <div className="card" style={{width:"300px"}}>
              <div className="card-header" style={{
                color: "#373737",
                fontFamily: "Nunito",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "600",
                lineHeight: "120%",
                letterSpacing: "0.016px"
                }}>
                Your password must meet the following requirements:
              </div>
              <div className="card-body" style={{
                paddingLeft:"0px",
                color: "#373737",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "150%",
                }}>
                <ul>
                  <li>Contain at least 8 characters (12+ recommended)</li>
                  <li>Contain at least one uppercase letter</li>
                  <li>
                  <p dangerouslySetInnerHTML={{ __html: 'Contain at least one special character (!&ldquo;#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~ )' }} />
                  </li>
                </ul>
              </div>
          </div>
        
      </Popover>
      </PasswordInstructions>
      <Controller
        control={control}
        name={'email'}
        render={({ field: {ref, ...rest}}) => (
          <InputContainer>
            <TextInput
              errorMsg={_get(errors.email, 'message') || ''}
              id={'email'}
              
              openSans
              placeholder={'Enter your email'}
              disabled
              icon={'LockClosed'}
              label={'Enter your email'}
              required
              {...rest}
            />
          </InputContainer>
        )}
      />
      <Controller
        control={control}
        name={'password'}
        render={({ field: {ref, ...rest}}) => (
          <InputContainer>
            <TextInput
              errorMsg={_get(errors.password, 'message') || ''}
              id={'password'}
              readAlertCustom={true}
              openSans
              placeholder={'Enter your password'}
              label={'Enter your password'}
              required
              sensitive
              autoComplete={"off"}
              {...rest}
            />
          </InputContainer>
        )}
      />
      <Controller
        control={control}
        name={'passwordConfirm'}
        render={({ field: {ref, ...rest}}) => (
          <InputContainer>
            <TextInput
              errorMsg={_get(errors.passwordConfirm, 'message') || ''}
              id={'passwordConfirm'}
              readAlertCustom={true}
              openSans
              placeholder={'Confirm your password'}
              label={'Confirm your password'}
              required
              sensitive
              autoComplete={"off"}
              {...rest}
            />
          </InputContainer>
        )}
      />
     
    </>
  );
}